import type { Typography } from 'antd';
import type { SizeType } from 'antd/es/config-provider/SizeContext';
import type { ComponentProps } from 'react';

export type FormSize = 'default' | 'small';

export type TitleLevel = NonNullable<
  ComponentProps<typeof Typography.Title>['level']
>;

export type FormSizeTokens = {
  sectionTitleLevel: TitleLevel;
  subsectionTitleLevel: TitleLevel;
  inputSize: SizeType;
};

/* Control heights are uniform platform-wide — `small` only compacts section
   titles. Explicit `componentProps.size` remains the escape hatch for truly
   dense contexts (inline table editors, toolbars). */
const SIZE_TOKENS: Record<FormSize, FormSizeTokens> = {
  default: {
    sectionTitleLevel: 4,
    subsectionTitleLevel: 5,
    inputSize: 'middle',
  },
  small: {
    sectionTitleLevel: 5,
    subsectionTitleLevel: 5,
    inputSize: 'middle',
  },
};

export function getFormSizeTokens(size: FormSize = 'default'): FormSizeTokens {
  return SIZE_TOKENS[size];
}
